import { createSlice } from "@reduxjs/toolkit";

const bookingState = {
  paidList: [],
  adminBookingList: [],
  collectedList: [],
  requestsList: [],
  historyList: [],
  paymentsList: [],
  adminPaymentsList: [],
};

const reducers = {
  getAdminBookingList: (state: any, action: any) => {
    const items = action.payload.items;

    state.adminBookingList = items;
  },
  getAdminPaymentsList: (state: any, action: any) => {
    const items = action.payload.items;

    state.adminPaymentsList = items;
  },
  getUserPaymentsList: (state: any, action: any) => {
    const items = action.payload.items;

    state.paymentsList = items;
  },
  getPaidList: (state: any, action: any) => {
    const items = action.payload.items;

    state.paidList = items;
  },
  updatePaidItem: (state: any, action: any) => {
    const temp = [...state.paidList];
    const newItem = action.payload.item;
    const index = temp.findIndex((item) => item.id === newItem.id);
    state.paidList[index] = newItem;
  },
  deletePaidItem: (state: any, action: any) => {
    const tempItems = [...state.paidList];
    const itemId = action.payload.id;
    const updatedList = tempItems.filter((item) => item.id !== itemId);
    state.paidList = updatedList;
  },
  getCollectedList: (state: any, action: any) => {
    const items = action.payload.items;

    state.collectedList = items;
  },
  updateCollectedItem: (state: any, action: any) => {
    const temp = [...state.collectedList];
    const newItem = action.payload.item;
    const index = temp.findIndex((item) => item.id === newItem.id);
    state.collectedList[index] = newItem;
  },
  deleteCollectedItem: (state: any, action: any) => {
    const tempItems = [...state.collectedList];
    const itemId = action.payload.id;
    const updatedList = tempItems.filter((item) => item.id !== itemId);
    state.collectedList = updatedList;
  },
  getRequestsList: (state: any, action: any) => {
    const items = action.payload.items;

    state.requestsList = items;
  },
  updateRequestsItem: (state: any, action: any) => {
    const temp = [...state.requestsList];
    const newItem = action.payload.item;
    const index = temp.findIndex((item) => item.id === newItem.id);
    state.requestsList[index] = newItem;
  },
  deleteRequestsItem: (state: any, action: any) => {
    const tempItems = [...state.requestsList];
    const itemId = action.payload.id;
    const updatedList = tempItems.filter((item) => item.id !== itemId);
    state.requestsList = updatedList;
  },
  getHistoryList: (state: any, action: any) => {
    const items = action.payload.items;

    state.historyList = items;
  },
  updateHistoryItem: (state: any, action: any) => {
    const temp = [...state.historyList];
    const newItem = action.payload.item;
    const index = temp.findIndex((item) => item.id === newItem.id);
    state.historyList[index] = newItem;
  },
  deleteHistoryItem: (state: any, action: any) => {
    const tempItems = [...state.historyList];
    const itemId = action.payload.id;
    const updatedList = tempItems.filter((item) => item.id !== itemId);
    state.historyList = updatedList;
  },
};

const BookingSlice = createSlice({
  name: "auth",
  initialState: bookingState,
  reducers: reducers,
});

export const {
  getAdminBookingList,
  getAdminPaymentsList,
  getUserPaymentsList,
  getPaidList,
  getCollectedList,
  getHistoryList,
  getRequestsList,
  updatePaidItem,
  updateCollectedItem,
  updateRequestsItem,
  updateHistoryItem,
  deletePaidItem,
  deleteCollectedItem,
  deleteHistoryItem,
  deleteRequestsItem,
} = BookingSlice.actions;

export default BookingSlice.reducer;
